module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-3e2c4057.png";